import { render } from "./CalcBuilding.vue?vue&type=template&id=335a32a5"
import script from "./CalcBuilding.vue?vue&type=script&lang=js"
export * from "./CalcBuilding.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__